import { getContext } from 'svelte';
const useFilter = () => getContext('filter');
export default useFilter;
